<template lang="pug">
  a.panel.main(href="#" @click.prevent.stop="edit('main')")
    .icon
      svg.default-icon(
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      )
        path(
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.3"
          d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        )
      edit-icon
    .data
      .grid
        .name
          .label Name
          .name-value {{ name }}
        .birthdate
          .label Geburtsdatum
          .name-value {{ birthdate }}
        .phone
          .label Mobilnummer
          .name-value {{ mobile }}

    portal(to="modals")
      Modal(v-if="modal" @dismiss="dismiss" @close="close")
        validation-observer(v-slot="{ invalid }" ref="form")
          Spinner(v-if="loading" :size="16" :thickness="3")
          .p-4.bg-gray-200.rounded-t
            form(@submit.prevent="submit")
              fieldset
                select-with-validation.select-field(
                  rules="required"
                  name="Anrede"
                  v-model="form.gender"
                  :options="genders"
                  :multiple="false"
                  :searchable="false"
                  :allow-empty="false"
                  :show-labels="true"
                  track-by="value"
                  label="label"
                  placeholder="bitte wählen..."
                  deselect-label="mit Enter abwählen"
                  selected-label="ausgewählt"
                  select-label="mit Enter auswählen"
                )
              fieldset.form-field
                validation-provider(name="Vorname" rules="required" v-slot="{ errors }")
                  label.label(for="first-name") Vorname
                  .control.has-icons-right
                    input#first-name.input(
                      type="text"
                      name="first_name"
                      v-model="form.first_name"
                      :class="{ 'is-danger': errors && errors.length }"
                    )
                    span.icon
                      font-awesome-icon(icon="user")
                  p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                  p.help.has-text-grey(v-else) Pflichtfeld
              fieldset.form-field
                validation-provider(name="Nachname" rules="required" v-slot="{ errors }")
                  label.label(for="last-name") Nachname
                  .control.has-icons-right
                    input#last-name.input(
                      type="text"
                      name="last_name"
                      v-model="form.last_name"
                      :class="{ 'is-danger': errors && errors.length }"
                    )
                    span.icon
                      font-awesome-icon(icon="user")
                  p.help.is-danger(v-if="errors && errors.length") {{ errors[0] }}
                  p.help.has-text-grey(v-else) Pflichtfeld
              fieldset.form-field
                label.label(for="birthdate") Geburtsdatum
                .control.has-icons-right
                  input#birthdate.input(
                    type="date"
                    name="birthdate"
                    v-model="form.date_of_birth"
                  )
                  span.icon
                    font-awesome-icon(icon="calendar-check")
              fieldset.form-field
                label.label(for="mobile") Mobilnummer
                .control.has-icons-right
                  input#mobile.input(
                    type="tel"
                    name="mobile"
                    v-model="form.mobile"
                  )
                  span.icon
                    font-awesome-icon(icon="phone")
          .bg-gray-100.p-4.rounded-b(class="md:flex md:flex-row-reverse md:justify-between")
            button.button(type="button" @click="submit" :disabled="invalid") Speichern
            button.button.is-outlined(type="button" @click="close") Abbrechen
</template>

<script>
import Vue from 'vue';
import uniqid from 'uniqid';

import { mapGetters, mapActions } from 'vuex';

import { trim } from '@/helpers';
import { formatTimestamp, date2timestamp } from '@/filters';

import { VueReCaptcha } from 'vue-recaptcha-v3';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import SelectWithValidation from '@/components/Partials/SelectWithValidation';
import EditIcon from '@/extensions/restricted-area/components/UserForm/Partials/EditIcon';
import Modal from '@/components/Modal';

export default {
  name: 'AccountMain',
  data: () => ({
    modal: false,
    loading: false,
    genders: [
      {
        value: 'M',
        label: 'Herr'
      },
      {
        value: 'F',
        label: 'Frau'
      },
      {
        value: 'X',
        label: 'Sonstiges'
      }
    ],
    form: {
      gender: undefined,
      first_name: '',
      last_name: '',
      date_of_birth: undefined,
      mobile: ''
    }
  }),
  components: {
    EditIcon,
    Modal,
    ValidationObserver,
    ValidationProvider,
    SelectWithValidation
  },
  computed: {
    name() {
      return trim(`${this.member.first_name} ${this.member.last_name}`) || '--';
    },
    birthdate() {
      let birthdate = '--';
      const timestamp = this.member.date_of_birth;
      if (timestamp !== undefined && timestamp !== null) birthdate = formatTimestamp(timestamp);
      return birthdate;
    },
    mobile() {
      return this.member.mobile || '--';
    },
    ...mapGetters({
      member: 'auth/member',
      recaptchaSiteKey: 'googleRecaptchaSiteKey'
    })
  },
  methods: {
    edit() {
      const gender = this.genders.find(el => el.value === this.member.gender);

      let date_of_birth;
      const timestamp = this.member.date_of_birth;
      if (timestamp !== undefined && timestamp !== null) {
        date_of_birth = formatTimestamp(this.member.date_of_birth, 'yyyy-MM-dd');
      }
      this.form = {
        gender,
        first_name: this.member.first_name,
        last_name: this.member.last_name,
        date_of_birth,
        mobile: this.member.mobile
      };

      this.modal = true;
    },
    dismiss() {
      // if (this.form.current_password === '' && this.form.email === '') {
      //   this.close();
      // }
    },
    close() {
      this.modal = false;
      this.$nextTick(() => {
        this.form = {
          gender: undefined,
          first_name: '',
          last_name: '',
          date_of_birth: undefined,
          mobile: ''
        };
      });
    },
    async submit() {
      this.loading = true;

      // TODO
      // 1. check the current password
      // 2. if succeed: submit member form with new email

      const valid = await this.$refs.form.validate();
      if (!valid) {
        const errorMessage = {
          id: uniqid(),
          title: 'Ungültiges Formular',
          text: 'Korrigieren Sie Ihre Angaben.',
          type: 'warning',
          autoclose: 8000
        };
        this.addMessage(errorMessage);
      } else {
        let errorMessage = {
          id: uniqid(),
          title: 'Fehler',
          text: 'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
          type: 'error',
          autoclose: 8000
        };
        if (this.recaptchaSiteKey) {
          await this.$recaptchaLoaded();
          try {
            await this.$recaptcha('auth');
            const payload = {
              id: parseInt(this.member.id),
              gender: this.form.gender.value,
              first_name: this.form.first_name,
              last_name: this.form.last_name,
              date_of_birth: date2timestamp(this.form.date_of_birth, 'yyyy-MM-dd'),
              mobile: this.form.mobile
            };
            this.updateMember(payload)
              .then(() => {
                this.addMessage({
                  id: uniqid(),
                  title: 'Erfolg',
                  text: 'Ihre Benutzerdaten wurden erfolgreich geändert.',
                  type: 'success',
                  autoclose: 4000
                });
                this.close();
              })
              .catch(error => {
                console.error(error);
                this.addMessage(errorMessage);
              })
              .finally(() => {
                this.loading = false;
              });
          } catch (error) {
            console.error(error);
            this.loading = false;
            this.addMessage(errorMessage);
          }
        } else {
          console.error('No ReCaptcha key!');
          this.loading = false;
          this.addMessage(errorMessage);
        }
      }
    },
    ...mapActions({
      addMessage: 'message/add',
      updateMember: 'auth/updateMember'
    })
  },
  beforeMount() {
    if (this.recaptchaSiteKey) {
      Vue.use(VueReCaptcha, {
        siteKey: this.recaptchaSiteKey,
        loaderOptions: {
          useRecaptchaNet: true
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.grid
  display: grid
  grid-template-rows: auto
  grid-gap: 1rem
  @screen md
    grid-template-columns: repeat(2, auto)
    .phone
      grid-column: 1
  @screen lg
    grid-row-gap: 2.5rem
  @screen xl
    grid-template-columns: repeat(3, auto)
    .phone
      grid-column: 3

.spinner-container
  position: absolute
  left: 0
  width: 100%
  top: 0
  height: 100%
  z-index: 1
  background: rgba(255, 255, 255, 0.5)
form
  fieldset.form-field:last-child
    @apply mb-0
</style>
